import SelectService from '@/views/SelectService/index.vue'

const SelectServiceRouter = {
  path: '/select-service',
  name: 'SelectService',
  component: SelectService,
  props: (route) => ({
    secret: route.query.secret
  })
}

export default SelectServiceRouter
